import React, { useCallback, useState } from 'react';
import styled from 'styled-components';
import MultiStepActivationContainer from './Components/MultiStepActivationContainer';
import { useTranslation } from 'react-i18next';
import BeSureToAllowSlide from './Components/BeSureToAllowSlide';
import { hasSliideOrigin } from '.';
import { useQuery } from '../Common/Hooks';
import { MultiStepStyledButton } from './PartnerPluginActivateMultiStepAlmostThere';
import { addSliideText } from './PartnerPluginActivateMultiStep';
import clsx from 'clsx';

export const HyperisePlaceholderContainer = styled.div`
  width: 100%;
  height: fit-content;
`;

const BodyContentContainer = styled.div`
  width: 320px;
  margin-top: 21px;
  margin-left: 35px;
  min-height: 500px;
`;

const StyledContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  margin-bottom: 20px;
  margin-top: 20px;
`;

const PartnerPluginActivateMultiStepBeSureToAllow = () => {
  const { t } = useTranslation();
  const query = useQuery();
  const [sliide] = useState(hasSliideOrigin());

  const openApp = useCallback(() => {
    const origin = query.get('origin');
    if (origin)
      window.location = `${origin}://` as (string | Location) & Location;
  }, [query]);

  return (
    <MultiStepActivationContainer
      headerTextColor="white"
      backgroundColor="#323A68"
      sliideSubtitle="PartnerpluginsdkActivate.multiStep.forTheBestExperience"
      headerText={
        'PartnerpluginsdkActivate.multiStep.beSureToAllow' +
        addSliideText(sliide)
      }
      headerTextTopPadding={20}
      showBodyGradient={!sliide}
      sliide={sliide}
    >
      <BodyContentContainer>
        <BeSureToAllowSlide sliide={sliide} />
        <StyledContainer>
          <MultiStepStyledButton className={clsx({ sliide })} onClick={openApp}>
            {t('PartnerpluginsdkActivate.multiStep.goAppToApp')}
          </MultiStepStyledButton>
        </StyledContainer>
      </BodyContentContainer>
    </MultiStepActivationContainer>
  );
};

export default PartnerPluginActivateMultiStepBeSureToAllow;
